










import { Component, Prop, Vue } from "vue-property-decorator";
import "flag-icon-css/css/flag-icon.min.css";

@Component
export default class CountryFlag extends Vue {
  @Prop({ required: true })
  public countryCode!: string;

  @Prop({ default: false })
  public isSquared!: boolean;
}
